module.exports = __webpack_public_path__ + "static/media/logo-natural-stone.c72ff333.svg";